import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'foodShelterSearchfilter'
})
export class FoodShelterSearchfilterPipe implements PipeTransform {
  list: any;
  result: any;
  transform(items: any[], filter: string): any {
    if (!items || !filter) {
      return items;
    }

    this.result = [];
    items.forEach(element => {
      this.list = [];
      this.list = element.values.filter(item => item.agencyName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.service.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.address.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.eligibility.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.phoneNumber.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.hours.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.websiteUrl.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
      if (this.list.length > 0) {
        this.result.push({ name: element.name, values: this.list });
      }
    });
    return this.result;
  }
}
